export default function timeFormatter(date) {
  const fecha = new Date(date);

  return fecha.toLocaleTimeString('es-ES', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}
